import { render, staticRenderFns } from "./contentLoader.vue?vue&type=template&id=b09c3132&scoped=true&"
import script from "./contentLoader.vue?vue&type=script&lang=js&"
export * from "./contentLoader.vue?vue&type=script&lang=js&"
import style0 from "./contentLoader.vue?vue&type=style&index=0&id=b09c3132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09c3132",
  null
  
)

export default component.exports